import { call, put } from "redux-saga/effects";
import { trackingConstants } from "../actions/constants/trackingConstants";
import { locationTrackingService } from "../services/locationTrackingService";

function* listSessions(action: any): any {
    try {
        const response = yield call(locationTrackingService.listSessions, action.payload);
        if (response.success) {
            yield put({ type: trackingConstants.listSessionsSuccess, payload: response.resultObject });
        } else {
            yield put({ type: trackingConstants.listSessionsFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: trackingConstants.listSessionsFailure, payload: error });
    }
}

function* viewSession(action: any): any {
    try {
        const response = yield call(locationTrackingService.viewSession, action.payload);
        if (response.success) {
            yield put({ type: trackingConstants.viewSessionSuccess, payload: response.resultObject });
        } else {
            yield put({ type: trackingConstants.viewSessionFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: trackingConstants.viewSessionFailure, payload: error });
    }
}

function* getActiveSessions(action: any): any {
    try {
        const response = yield call(locationTrackingService.getActiveSessions, action.payload);
        if (response.success) {
            yield put({ type: trackingConstants.getActiveSessionsSuccess, payload: response.resultObject });
        } else {
            yield put({ type: trackingConstants.getActiveSessionsFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: trackingConstants.getActiveSessionsFailure, payload: error });
    }
}

function* getSessionByBatchToday(action: any): any {
    try {
        const response = yield call(locationTrackingService.getSessionByBatchToday, action.payload);
        if (response.success) {
            yield put({ type: trackingConstants.getSessionByBatchTodaySuccess, payload: response.resultObject });
        } else {
            yield put({ type: trackingConstants.getSessionByBatchTodayFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: trackingConstants.getSessionByBatchTodayFailure, payload: error });
    }
}

function* historyList(action: any): any {
    try {
        const response = yield call(locationTrackingService.historyList, action.payload);
        if (response.success) {
            yield put({ type: trackingConstants.historyListSuccess, payload: response.resultObject });
        } else {
            yield put({ type: trackingConstants.historyListFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: trackingConstants.historyListFailure, payload: error });
    }
}

function* viewSessionWithStudents(action: any): any {
    try {
        const { id, studentId, tripCount } = action.payload;
        const params: any = {};
        if (studentId) params.studentId = studentId;
        if (tripCount != null) params.tripCount = tripCount;
        const response = yield call(locationTrackingService.viewSessionWithStudents, id, Object.keys(params).length ? params : undefined);
        if (response.success) {
            yield put({ type: trackingConstants.viewSessionStudentsSuccess, payload: response.resultObject });
        } else {
            yield put({ type: trackingConstants.viewSessionStudentsFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: trackingConstants.viewSessionStudentsFailure, payload: error });
    }
}

function* generateShareToken(action: any): any {
    try {
        const response = yield call(locationTrackingService.generateShareToken, action.payload);
        if (response.success) {
            yield put({ type: trackingConstants.generateShareTokenSuccess, payload: response.resultObject });
        } else {
            yield put({ type: trackingConstants.generateShareTokenFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: trackingConstants.generateShareTokenFailure, payload: error });
    }
}

function* disableShare(action: any): any {
    try {
        const response = yield call(locationTrackingService.disableShare, action.payload);
        if (response.success) {
            yield put({ type: trackingConstants.disableShareSuccess, payload: response.resultObject });
        } else {
            yield put({ type: trackingConstants.disableShareFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: trackingConstants.disableShareFailure, payload: error });
    }
}

function* getShareStatus(action: any): any {
    try {
        const response = yield call(locationTrackingService.getShareStatus, action.payload);
        if (response.success) {
            yield put({ type: trackingConstants.getShareStatusSuccess, payload: response.resultObject });
        } else {
            yield put({ type: trackingConstants.getShareStatusFailure, payload: response.errorMessage });
        }
    } catch (error) {
        yield put({ type: trackingConstants.getShareStatusFailure, payload: error });
    }
}

export const trackingSaga = {
    listSessions,
    viewSession,
    getActiveSessions,
    getSessionByBatchToday,
    historyList,
    viewSessionWithStudents,
    generateShareToken,
    disableShare,
    getShareStatus,
};
